<template>
  <VerticalNavigation :items="items"/>
</template>

<script>
import ChartBarIcon from '../../../../../../components/Icons/Old/ChartBarIcon.vue'
import EditIcon from '../../../../../../components/Icons/Old/EditIcon'
import NewspaperIcon from '../../../../../../components/Icons/Old/NewspaperIcon'
import VerticalNavigation from '../../../../../../components/VerticalNavigation'
import UsersIcon from "../../../../../../components/Icons/Old/UsersIcon";

export default {
  components: {VerticalNavigation},

  props: {
    company: {
      required: true
    },

    portalCompany:{
      required: true
    }
  },

  computed: {
    items() {
      return [
        {
          name: 'Dashboard',
          to: '/companies/' + this.company.id + '/portals/' + this.portalCompany.id,
          icon: ChartBarIcon
        },
        {
          name: 'Brands',
          to: '/companies/' + this.company.id + '/portals/' + this.portalCompany.id + '/brands',
          group: true,
          icon: NewspaperIcon
        },
        {
          name: 'Contacts',
          to: '/companies/' + this.company.id + '/portals/' + this.portalCompany.id + '/contacts',
          group: true,
          icon: UsersIcon
        },
        {
          name: 'Edit',
          to: '/companies/' + this.company.id + '/portals/' + this.portalCompany.id + '/edit',
          icon: EditIcon
        },
      ]
    }
  }
}
</script>
